import * as tslib_1 from "tslib";
import { CartActions } from '@wix/wixstores-client-core/dist/es/src/cart-actions/cartActions';
import { ProductActions } from '@wix/wixstores-client-core/dist/es/src/product-actions/ProductActions';
import { PageMap } from '@wix/wixstores-client-core/dist/es/src/constants';
var ProductService = /** @class */ (function () {
    function ProductService(siteStore, pubSubManager, compId, externalId, fedopsLogger) {
        this.siteStore = siteStore;
        this.compId = compId;
        this.externalId = externalId;
        this.fedopsLogger = fedopsLogger;
        this.cartActions = new CartActions(this.siteStore, pubSubManager, 'product-page', PageMap.CART);
        this.productActions = new ProductActions(this.siteStore);
    }
    ProductService.prototype.trackAddToCartBI = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var eventData;
            return tslib_1.__generator(this, function (_a) {
                eventData = {
                    appName: 'productWidgetApp',
                    hasOptions: false,
                    productId: product.id,
                    productType: product.productType,
                    origin: 'product-widget',
                };
                return [2 /*return*/, this.siteStore.biLogger.clickOnAddToCartSf(eventData)];
            });
        });
    };
    ProductService.prototype.addToCart = function (product, navigate) {
        var _this = this;
        if (navigate === void 0) { navigate = false; }
        var customTextFields = undefined;
        var selectionIds = undefined;
        var quantity = 1;
        if (navigate) {
            return this.siteStore.navigate({
                sectionId: PageMap.PRODUCT,
                state: product.urlPart,
                queryParams: undefined,
            }, true);
        }
        else if (!product.hasOptions) {
            // tslint:disable-next-line no-floating-promises
            this.trackAddToCartBI(product);
            this.fedopsLogger.interactionStarted('add-to-cart');
            return this.cartActions.addToCart(product.id, selectionIds, quantity, customTextFields, true).then(function () {
                _this.fedopsLogger.interactionEnded('add-to-cart');
            });
        }
        else {
            return this.productActions.quickViewProduct(product.id, 'productwidget', product.urlPart, this.compId, this.externalId);
        }
    };
    return ProductService;
}());
export { ProductService };
//# sourceMappingURL=ProductService.js.map